// extracted by mini-css-extract-plugin
module.exports = {"fullContainer":"LoadingSpinner_fullContainer__dLM-_ flex justify-center items-center absolute"};